// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IconArrowDefaultDown = function IconArrowDefaultDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"title","attr":{}},{"tag":"polygon","attr":{"id":"fill-color","points":"11 4 13 4 13 16 18.5 10.5 19.92 11.92 12 19.84 4.08 11.92 5.5 10.5 11 16"}}]})(props);
};
